<div class="support-page container-fluid">
    <div class="support-hero card-borderless">
        <div class="hero-content">
            <div class="hero-left">
                <div class="brand-badge">
                    <span class="brand-icon">
                        <img src="/assets/images/brainex.png" alt="Brainex World">
                    </span>
                    <div>
                        <h6 class="mb-0">Brainex World (Pvt). Ltd</h6>
                        <small>Support Center</small>
                    </div>
                </div>

                <h2 class="hero-title">
                    Need help with your system?
                </h2>

                <p class="hero-subtitle">
                    If you face any issue in a module, need clarification, or want us to review something,
                    you can contact support here through WhatsApp or by submitting a support request.
                </p>

                <div class="hero-points">
                    <div class="hero-point">
                        <i class="bi bi-whatsapp"></i>
                        <span>Quick WhatsApp help</span>
                    </div>
                    <div class="hero-point">
                        <i class="bi bi-ticket-detailed"></i>
                        <span>Submit a support request</span>
                    </div>
                    <div class="hero-point">
                        <i class="bi bi-envelope"></i>
                        <span>Direct email support</span>
                    </div>
                </div>
            </div>

            <div class="hero-right">
                <div class="profile-card support-brand-card">
                    <div class="avatar">BW</div>
                    <div class="profile-meta">
                        <h5>Brainex World Support</h5>
                        <p>brainexw&#64;gmail.com</p>
                        <span>+92 343 6523451</span>
                    </div>
                </div>

                <div class="contact-card">
                    <div class="contact-item">
                        <i class="bi bi-whatsapp"></i>
                        <div>
                            <small>WhatsApp</small>
                            <strong>+92 343 6523451</strong>
                        </div>
                    </div>
                    <div class="contact-item">
                        <i class="bi bi-envelope-paper"></i>
                        <div>
                            <small>Email</small>
                            <strong>brainexw&#64;gmail.com</strong>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row g-4 mt-1">
        <div class="col-12 col-xl-7">
            <div class="support-card">
                <div class="card-head">
                    <div>
                        <h4>Submit a Support Request</h4>
                        <p>
                            Share the module name, issue details, and expected solution so we can review it properly.
                        </p>
                    </div>
                    <div class="head-icon">
                        <i class="bi bi-life-preserver"></i>
                    </div>
                </div>

                <div *ngIf="submitSuccessMessage" class="alert alert-success soft-alert mb-3">
                    <i class="bi bi-check-circle-fill me-2"></i>{{ submitSuccessMessage }}
                </div>

                <div *ngIf="submitErrorMessage" class="alert alert-danger soft-alert mb-3">
                    <i class="bi bi-exclamation-triangle-fill me-2"></i>{{ submitErrorMessage }}
                </div>

                <form [formGroup]="supportForm" (ngSubmit)="submitTicket()" novalidate>
                    <div class="row g-3">
                        <div class="col-12 col-md-6">
                            <label class="form-label">Your Name</label>
                            <input type="text" class="form-control custom-control" formControlName="clientName"
                                placeholder="Enter your full name" />
                        </div>

                        <div class="col-12 col-md-6">
                            <label class="form-label">Your Email</label>
                            <input type="email" class="form-control custom-control" formControlName="clientEmail"
                                placeholder="Enter your email address" />
                            <div class="field-error" *ngIf="hasError('clientEmail', 'email')">
                                Please enter a valid email address.
                            </div>
                        </div>

                        <div class="col-12 col-md-6">
                            <label class="form-label">Your Phone</label>
                            <input type="text" class="form-control custom-control" formControlName="clientPhone"
                                placeholder="Enter your phone number" />
                        </div>

                        <div class="col-12 col-md-6">
                            <label class="form-label">Module Name <span class="req">*</span></label>
                            <select class="form-select custom-control" formControlName="moduleName">
                                <option value="">Select module</option>
                                <option *ngFor="let module of modules" [value]="module">{{ module }}</option>
                            </select>
                            <div class="field-error" *ngIf="hasError('moduleName')">
                                Module name is required.
                            </div>
                        </div>

                        <div class="col-12">
                            <label class="form-label">Issue Title <span class="req">*</span></label>
                            <input type="text" class="form-control custom-control" formControlName="issueTitle"
                                placeholder="Example: Messages not sending in chat module" />
                            <div class="field-error" *ngIf="hasError('issueTitle')">
                                Issue title is required.
                            </div>
                        </div>

                        <div class="col-12">
                            <label class="form-label">Error Message</label>
                            <input type="text" class="form-control custom-control" formControlName="errorMessage"
                                placeholder="Example: 500 Internal Server Error" />
                        </div>

                        <div class="col-12">
                            <label class="form-label">Issue Details <span class="req">*</span></label>
                            <textarea class="form-control custom-control textarea-lg" formControlName="description"
                                rows="5"
                                placeholder="Please describe the issue clearly. Mention what happened and where it happened."></textarea>
                            <div class="field-error" *ngIf="hasError('description')">
                                Description is required.
                            </div>
                        </div>

                        <div class="col-12">
                            <label class="form-label">Expected Solution</label>
                            <textarea class="form-control custom-control" formControlName="expectedSolution" rows="3"
                                placeholder="Describe the result or fix you want."></textarea>
                        </div>

                        <div class="col-12 col-md-4">
                            <label class="form-label">Priority</label>
                            <select class="form-select custom-control" formControlName="priority">
                                <option *ngFor="let priority of priorities" [value]="priority">{{ priority }}</option>
                            </select>
                        </div>

                        <div class="col-12 col-md-8">
                            <label class="form-label">Attachment</label>
                            <input type="file" class="form-control custom-control"
                                accept=".jpg,.jpeg,.png,.webp,.gif,.pdf,.doc,.docx,.xls,.xlsx,.txt"
                                (change)="onAttachmentSelected($event)" />

                            <div class="mt-2" *ngIf="selectedAttachmentName">
                                <small class="text-muted">
                                    Selected file: <strong>{{ selectedAttachmentName }}</strong>
                                </small>
                            </div>

                            <div class="field-error" *ngIf="attachmentError">
                                {{ attachmentError }}
                            </div>
                        </div>

                    </div>

                    <div class="support-actions">
                        <button type="button" class="btn btn-whatsapp" [disabled]="isWhatsAppLoading"
                            (click)="openWhatsAppSupport()">
                            <span *ngIf="!isWhatsAppLoading">
                                <i class="bi bi-whatsapp me-2"></i>Chat on WhatsApp
                            </span>
                            <span *ngIf="isWhatsAppLoading">
                                <span class="spinner-border spinner-border-sm me-2"></span>Opening WhatsApp...
                            </span>
                        </button>

                        <button type="submit" class="btn btn-submit" [disabled]="isSubmitting">
                            <span *ngIf="!isSubmitting">
                                <i class="bi bi-send-check me-2"></i>Submit Request
                            </span>
                            <span *ngIf="isSubmitting">
                                <span class="spinner-border spinner-border-sm me-2"></span>Submitting...
                            </span>
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <div class="col-12 col-xl-5">
            <div class="side-stack">
                <div class="info-card whatsapp-card">
                    <div class="info-top">
                        <div class="icon-wrap whatsapp">
                            <i class="bi bi-whatsapp"></i>
                        </div>
                        <div>
                            <h5>WhatsApp Support</h5>
                            <p>Use WhatsApp for quick communication or urgent discussion.</p>
                        </div>
                    </div>

                    <ul class="feature-list">
                        <li><i class="bi bi-check2"></i>Fast communication</li>
                        <li><i class="bi bi-check2"></i>Direct support contact</li>
                        <li><i class="bi bi-check2"></i>Easy issue sharing</li>
                    </ul>

                    <button class="btn btn-whatsapp w-100" [disabled]="isWhatsAppLoading"
                        (click)="openWhatsAppSupport()">
                        <i class="bi bi-whatsapp me-2"></i>Open WhatsApp
                    </button>
                </div>

                <div class="info-card ticket-card">
                    <div class="info-top">
                        <div class="icon-wrap ticket">
                            <i class="bi bi-ticket-detailed"></i>
                        </div>
                        <div>
                            <h5>Recent Support Requests</h5>
                            <p>View your recent submitted requests and their current status.</p>
                        </div>
                    </div>

                    <div class="loading-wrap" *ngIf="isTicketsLoading">
                        <div class="spinner-border spinner-border-sm me-2"></div>
                        Loading requests...
                    </div>

                    <div class="empty-state" *ngIf="!isTicketsLoading && !recentTickets.length">
                        <i class="bi bi-inbox"></i>
                        <h6>No requests yet</h6>
                        <p>Your submitted requests will appear here.</p>
                    </div>

                    <div class="ticket-list" *ngIf="!isTicketsLoading && recentTickets.length">
                        <div class="ticket-item" *ngFor="let ticket of recentTickets">
                            <div class="ticket-top">
                                <div class="ticket-meta">
                                    <h6>{{ ticket.issueTitle }}</h6>
                                    <small>{{ ticket.ticketNo }} • {{ ticket.moduleName }}</small>
                                </div>

                                <button class="btn btn-sm btn-light view-btn" (click)="viewTicket(ticket)">
                                    View
                                </button>
                            </div>

                            <p class="ticket-desc">
                                {{ ticket.description }}
                            </p>

                            <div class="ticket-bottom">
                                <span class="badge-chip priority" [ngClass]="getPriorityClass(ticket.priority)">
                                    {{ ticket.priority }}
                                </span>

                                <span class="badge-chip status" [ngClass]="getStatusClass(ticket.status)">
                                    <i [class]="getStatusIcon(ticket.status)"></i>
                                    {{ ticket.status }}
                                </span>

                                <span class="ticket-date">{{ formatDate(ticket.createdAt) }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="info-card trust-card">
                    <div class="info-top">
                        <div class="icon-wrap trust">
                            <i class="bi bi-headset"></i>
                        </div>
                        <div>
                            <h5>Support Information</h5>
                            <p>You can reach us through WhatsApp for quick help or submit a request for detailed review.
                            </p>
                        </div>
                    </div>

                    <div class="mini-grid">
                        <div class="mini-box">
                            <strong>WhatsApp</strong>
                            <span>Quick contact for urgent or short issues</span>
                        </div>
                        <div class="mini-box">
                            <strong>Support Request</strong>
                            <span>Best for detailed issue reporting</span>
                        </div>
                        <div class="mini-box">
                            <strong>Issue Tracking</strong>
                            <span>Keep a clear record of submitted requests</span>
                        </div>
                        <div class="mini-box">
                            <strong>Direct Contact</strong>
                            <span>Reach Brainex World support easily</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="ticket-modal-backdrop" *ngIf="isTicketModalOpen" (click)="closeTicketModal()"></div>

    <div class="ticket-modal" *ngIf="isTicketModalOpen && selectedTicket">
        <div class="ticket-modal-card">
            <div class="modal-head">
                <div>
                    <h4>{{ selectedTicket.issueTitle }}</h4>
                    <p>{{ selectedTicket.ticketNo }} • {{ selectedTicket.moduleName }}</p>
                </div>
                <button class="close-btn" type="button" (click)="closeTicketModal()">
                    <i class="bi bi-x-lg"></i>
                </button>
            </div>

            <div class="modal-body-content">
                <div class="detail-grid">
                    <div class="detail-item">
                        <label>Name</label>
                        <strong>{{ selectedTicket.clientName || '-' }}</strong>
                    </div>
                    <div class="detail-item">
                        <label>Email</label>
                        <strong>{{ selectedTicket.clientEmail || '-' }}</strong>
                    </div>
                    <div class="detail-item">
                        <label>Phone</label>
                        <strong>{{ selectedTicket.clientPhone || '-' }}</strong>
                    </div>
                    <div class="detail-item">
                        <label>Created</label>
                        <strong>{{ formatDate(selectedTicket.createdAt) }}</strong>
                    </div>
                    <div class="detail-item">
                        <label>Priority</label>
                        <strong>{{ selectedTicket.priority }}</strong>
                    </div>
                    <div class="detail-item">
                        <label>Status</label>
                        <strong>{{ selectedTicket.status }}</strong>
                    </div>
                </div>

                <div class="detail-block">
                    <label>Error Message</label>
                    <div class="text-box">{{ selectedTicket.errorMessage || '-' }}</div>
                </div>

                <div class="detail-block">
                    <label>Issue Details</label>
                    <div class="text-box">{{ selectedTicket.description || '-' }}</div>
                </div>

                <div class="detail-block">
                    <label>Expected Solution</label>
                    <div class="text-box">{{ selectedTicket.expectedSolution || '-' }}</div>
                </div>

                <div class="detail-block" *ngIf="selectedTicket.attachmentUrl">
                    <label>Attachment</label>
                    <div class="text-box">
                        <a [href]="selectedTicket.attachmentUrl" target="_blank" rel="noopener noreferrer">
                            Open Attachment
                        </a>
                    </div>
                </div>

                <div class="ticket-tools">
                    <button class="btn btn-tool open" [disabled]="isUpdatingTicket" (click)="updateStatus('OPEN')">Mark
                        Open</button>
                    <button class="btn btn-tool progress" [disabled]="isUpdatingTicket"
                        (click)="updateStatus('IN_PROGRESS')">Mark In Progress</button>
                    <button class="btn btn-tool resolved" [disabled]="isUpdatingTicket"
                        (click)="updateStatus('RESOLVED')">Mark Resolved</button>
                    <button class="btn btn-tool delete" [disabled]="isUpdatingTicket"
                        (click)="deleteTicket(selectedTicket._id)">Delete</button>
                </div>

                <div class="detail-block">
                    <label>Add Note</label>
                    <div class="note-row">
                        <textarea [(ngModel)]="noteText" rows="3" class="form-control custom-control"
                            placeholder="Write a note..."></textarea>
                        <button class="btn btn-submit note-btn" [disabled]="isUpdatingTicket || !noteText.trim()"
                            (click)="addNote()">
                            Add Note
                        </button>
                    </div>
                </div>

                <div class="detail-block" *ngIf="selectedTicket.notes?.length">
                    <label>Notes</label>
                    <div class="notes-list">
                        <div class="note-item" *ngFor="let note of selectedTicket.notes">
                            <p>{{ note.message }}</p>
                            <small>{{ formatDate(note.addedAt) }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>